const queryParamsToString = (queryParams = {}) => {
  const entries = Object.entries(queryParams);

  if (!entries.length) return '';

  return `?${entries.map(([key, value]) => 
    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')}`;
}

export default queryParamsToString;